import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.emails', {
        url: '/emails',
        component: 'userEmails',
        resolve: {emails},
    })
}

/** @ngInject */
function emails(UserEmailsService) {
    return UserEmailsService.query().$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/emails/emails.state.js